export default {
  name: 'editComposition',
  path: '/composition',
  loadComponent: () => import('./index'),
  i18n: ['trading-desk/composition', 'trading-desk/flight']
};
